/* Package JSON Import will be here */
import React from 'react';
import "../../assets/styles/styles.css";
import './splashScreen.css';
import { Image } from 'semantic-ui-react';

const SplashScreenComponent = props => {

    return (
        <div className="container-fluid">
            <div className="splash-screen">
            <Image className="d-inline-block spalshImage" size='small' src={require('../../assets/images/logo_11.png')}></Image>
            <Image className="d-inline-block spalshGif" size='small' src={require('../../assets/images/60Hym.gif')}></Image>
                {/* Wait a moment while we load your app. */}
                {/* <div className="loading-dot">.</div> */}
            </div>
        </div>
    );
};

SplashScreenComponent.displayName = "SplashScreenComponent";

export default SplashScreenComponent;